import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { BaseDropdownOption, Dropdown } from '../../../../common/Dropdown';
import { GoalHeader } from '../../../../common/Goal';
import Header from '../../../../common/Header';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsProvider';
import { getAnalyticsDropdownOptions } from '../../constants';
import { TeamSelector } from '../TeamWiseStats/TeamSelector';

type TeamOption = {
  id: string;
  label: string;
  value: string;
};

function TopBar({
  selectedTeam,
  title,
  setSelectedTeam,
  hideGoalHeader,
}: {
  selectedTeam: TeamOption | null;
  setSelectedTeam: (team: TeamOption | null) => void;
  title: string;
  hideGoalHeader?: boolean;
}): JSX.Element {
  const { selectedPeriod, setSelectedPeriod } = useAnalytics();
  const location = useLocation();
  const href = location.pathname;
  const analyticsDropdownOptions = useMemo(
    () => getAnalyticsDropdownOptions(href),
    [href],
  );
  return (
    <div className="flex flex-col gap-6 w-full">
      <Header>{title}</Header>
      {!hideGoalHeader && <GoalHeader />}
      <div className="flex flex-row items-center gap-2">
        <TeamSelector
          selectedTeam={selectedTeam}
          onTeamChange={setSelectedTeam}
        />
        <Dropdown<BaseDropdownOption>
          name="teamName"
          label="Period"
          labelPosition="inline"
          className="w-36"
          variant="auto"
          options={analyticsDropdownOptions}
          value={selectedPeriod}
          onChange={(value) => value && setSelectedPeriod(value)}
        />
      </div>
    </div>
  );
}

export default TopBar;
